
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header'); // 固定ヘッダー要素
  const headerHeight = header ? header.offsetHeight : 0;

  // すべてのページ内リンクを取得
  const links = document.querySelectorAll('a[href^="#"]:not([href="#"])');

  links.forEach(link => {
    link.addEventListener('click', e => {
      const targetId = link.getAttribute('href');
      const target = document.querySelector(targetId);
      if (!target) return;

      e.preventDefault();

      const elementPosition = target.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerHeight; // ← ヘッダー高さ分を引く

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth' // スムーススクロール
      });
    });
  });
});

// ハンバーガーメニュー用 Vanilla JS
document.addEventListener("DOMContentLoaded", () => {
  const menuBtns = document.querySelectorAll("#menu, #sp-menu"); // 2つ取得
  const nav = document.getElementById("navmn");

  if (menuBtns.length > 0 && nav) {
    menuBtns.forEach(menuBtn => {
      menuBtn.addEventListener("click", () => {
        nav.classList.toggle("is-open");
        menuBtn.classList.toggle("is-active");
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".filter-menu__level--1>.filter-menu__item").forEach(function (element) {
    element.addEventListener("click", function (e) {
      const trigger = e.target.closest("summary, .plus");
      if (!trigger) {
        return;
      }

      let details;
      if (trigger.matches("summary")) {
        details = trigger.closest("details");
      } else {
        details = element.querySelector("details");
      }
      if (!details) {
        return;
      }

      const isOpen = details.hasAttribute("open");
      if (isOpen) {
        details.removeAttribute("open");
        element.classList.remove("active");
      } else {
        details.setAttribute("open", "open");
        element.classList.add("active");
      }

      e.preventDefault();
      e.stopPropagation();
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const slideshow = document.querySelector("slideshow-component");
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll("slideshow-slide");
  const thumbs = slideshow.querySelectorAll(".slideshow-controls__thumbnail");

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", (e) => {
      e.preventDefault();

      // 全スライド非表示
      slides.forEach(slide => slide.setAttribute("aria-hidden", "true"));

      // 選択スライドを表示
      slides[index].setAttribute("aria-hidden", "false");

      // サムネイル選択状態の切り替え
      thumbs.forEach(t => t.setAttribute("aria-selected", "false"));
      thumb.setAttribute("aria-selected", "true");

      // スライドのスクロール位置を変更（横方向に移動させる）
      const scroller = slideshow.querySelector("slideshow-slides");
      if (scroller) {
        const target = slides[index];
        scroller.scrollTo({
          left: target.offsetLeft,
          behavior: "smooth"
        });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const faqLists = document.querySelectorAll(".faq-list");

  faqLists.forEach(faq => {
    const question = faq.querySelector(".faq-question");

    question.addEventListener("click", () => {
      faq.classList.toggle("active");
    });
  });
});
